import React, { useEffect, useState } from 'react';

// FreeShippingBanner — sitewide announcement for the manually-toggled
// FREE SHIPPING campaign. Polls /api/free-shipping/status on mount.
// Rule (mirrored server-side in services/shipping.py):
//   Every physical cart item must be strictly under `max_item_price_usd`
//   (default $50). Multiple qualifying items still qualify.
//
// Publishes --free-shipping-banner-h so the fixed nav can shift below.
// Stacks BELOW the HolidayBanner (which uses --holiday-banner-h).

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function FreeShippingBanner() {
  const [status, setStatus] = useState(null);

  useEffect(() => {
    let cancelled = false;
    fetch(BACKEND + '/api/free-shipping/status')
      .then((r) => r.json())
      .then((d) => { if (!cancelled) setStatus(d); })
      .catch(() => {});
    // Poll every 60s so an admin toggle propagates to open sessions.
    const t = setInterval(() => {
      fetch(BACKEND + '/api/free-shipping/status')
        .then((r) => r.json())
        .then((d) => { if (!cancelled) setStatus(d); })
        .catch(() => {});
    }, 60000);
    return () => { cancelled = true; clearInterval(t); };
  }, []);

  const active = !!(status && status.active);
  const mode = (status && status.mode) || 'subtotal';
  const minUsd = status && status.min_usd;
  const maxUsd = status && status.max_usd;

  // Small human-readable qualifier line shown next to the big FREE SHIPPING label.
  let subline = '';
  const scope = mode === 'per_item' ? 'items' : 'orders';
  if (minUsd && maxUsd) subline = `on ${scope} from $${minUsd} to $${maxUsd}`;
  else if (minUsd && !maxUsd) subline = `on ${scope} $${minUsd}+`;
  else if (!minUsd && maxUsd) subline = `on ${scope} under $${maxUsd}`;
  else subline = 'on every order';

  // Slightly taller than the holiday banner because the type is bigger.
  const bannerHeight = 44;

  useEffect(() => {
    const root = document.documentElement;
    if (active) {
      root.style.setProperty('--free-shipping-banner-h', bannerHeight + 'px');
    } else {
      root.style.setProperty('--free-shipping-banner-h', '0px');
    }
    return () => { root.style.setProperty('--free-shipping-banner-h', '0px'); };
  }, [active]);

  if (!active) return null;

  return (
    <div
      data-testid="free-shipping-banner"
      className="fixed left-0 right-0 z-[69] w-full bg-gradient-to-r from-emerald-700 via-emerald-500 to-emerald-700 text-white shadow-md"
      style={{
        top: 'var(--holiday-banner-h, 0px)',
        height: bannerHeight + 'px',
      }}
    >
      <div className="max-w-7xl mx-auto px-3 h-full flex items-center justify-center gap-3 text-center">
        <span className="text-lg md:text-2xl font-black tracking-widest uppercase drop-shadow-sm">
          🚚 FREE SHIPPING
        </span>
        <span className="hidden sm:inline text-xs md:text-sm font-semibold opacity-90 tracking-wider">
          {subline}
        </span>
      </div>
    </div>
  );
}
